import React from 'react'
import FormLayout, { FormLayoutOuterProps } from '@cbgms/components/layout/FormLayout'
import SupportDeleteModalContainer from '../SupportDeleteModalContainer'

interface IFormLayoutOuterProps<FormData = any, Props = any, ErrorType = any>
  extends Omit<FormLayoutOuterProps<FormData, Props, ErrorType>, 'DeleteModalContainer'> {
  form: string
}

export const SupportFormLayout: React.FC<IFormLayoutOuterProps> = props => {
  return <FormLayout {...props} DeleteModalContainer={SupportDeleteModalContainer} />
}

export default SupportFormLayout
